import React, { useState } from "react";
import Header from "../../components/Header";
import { Box, Button, TextField, Snackbar, Alert } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import { useMediaQuery } from "@mui/material";
import {
  selectSponserID,
  selectCurrentToken,
} from "../../features/auth/authSlice";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const userSchema = yup.object().shape({
  image: yup.string().required("required"),
  title: yup.string().required("required"),
  content: yup.string().required("required"),
  price: yup.string().required("required"),
});

interface InitialValues {
  image: string | Blob;
  title: String;
  content: String;
  price: String;
}

const Index = () => {
  const token = useSelector(selectCurrentToken);
  const sponserId = useSelector(selectSponserID);
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [initialValues, setInitialValues] = useState({
    image: "",
    title: "",
    content: "",
    price: "",
  } as InitialValues);
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const handleFormSubmit = async (values: any) => {
    const formData = new FormData();
    formData.append("image", initialValues.image);
    formData.append("title", values.title);
    formData.append("content", values.content);
    formData.append("price", values.price);
    const response = await fetch(
      process.env.REACT_APP_ENV === "local"
        ? `/sponser/addFeed/${sponserId}`
        : process.env.REACT_APP_BACKEND_API + `/sponser/addFeed/${sponserId}`,
      {
        method: "POST",
        body: formData,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (response.status === 201) {
      setIsOpen(true);
      navigate("/feeds");
    }
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <div className="ml-5 mt-[100px]">
      <Header title="Add Feeds" subtitle="Add feeds" />
      <Box m="20px 20px 20px 0">
        <Formik
          onSubmit={handleFormSubmit}
          initialValues={initialValues}
          validationSchema={userSchema}
        >
          {/* @ts-ignore */}
          {({
            values,
            errors,
            touched,
            handleBlur,
            handleChange,
            handleSubmit,
          }) => {
            return (
              <form onSubmit={handleSubmit}>
                <Box
                  display={"grid"}
                  gap="8px"
                  gridTemplateColumns={"repeat(4, minmax(0,1fr))"}
                  sx={{
                    "& > div": {
                      gridColumn: isNonMobile ? undefined : "span 4",
                    },
                  }}
                >
                  <TextField
                    fullWidth
                    variant="outlined"
                    type={"text"}
                    label="Title"
                    onBlur={handleBlur}
                    onChange={(e) => {
                      handleChange(e);
                      setInitialValues({
                        ...initialValues,
                        title: e.target.value,
                      });
                    }}
                    value={initialValues.title}
                    name="title"
                    error={!!touched.title && !!errors.title}
                    helperText={<>{touched.title && errors.title}</>}
                    sx={{ gridColumn: "span 2" }}
                  />
                  <TextField
                    fullWidth
                    variant="outlined"
                    type={"number"}
                    label="Price"
                    onBlur={handleBlur}
                    onChange={(e) => {
                      handleChange(e);
                      setInitialValues({
                        ...initialValues,
                        price: e.target.value,
                      });
                    }}
                    onKeyDown={(evt) => evt.key === "e" && evt.preventDefault()}
                    value={initialValues.price}
                    name="price"
                    error={!!touched.price && !!errors.price}
                    helperText={<>{touched.price && errors.price}</>}
                    sx={{ gridColumn: "span 2" }}
                  />
                  <TextField
                    fullWidth
                    variant="outlined"
                    type={"text"}
                    label="Content"
                    onBlur={handleBlur}
                    onChange={(e) => {
                      handleChange(e);
                      setInitialValues({
                        ...initialValues,
                        content: e.target.value,
                      });
                    }}
                    value={initialValues.content}
                    name="content"
                    error={!!touched.content && !!errors.content}
                    helperText={<>{touched.content && errors.content}</>}
                    sx={{ gridColumn: "span 4" }}
                  />
                  <input
                    type={"file"}
                    onBlur={handleBlur}
                    accept="image/*"
                    onChange={(e) => {
                      handleChange(e);
                      if (!e.target.files) return;
                      setInitialValues({
                        ...initialValues,
                        image: e.target.files[0],
                      });
                    }}
                    name="image"
                  />
                </Box>
                <Box display="flex" justifyContent={"start"} mt="20px">
                  <Button type="submit" color="secondary" variant="contained">
                    Add Feed
                  </Button>
                </Box>
              </form>
            );
          }}
        </Formik>
        <Snackbar
          open={isOpen}
          autoHideDuration={6000}
          onClose={handleClose}
          message="Note archived"
        >
          <Alert
            onClose={handleClose}
            severity="success"
            sx={{ width: "100%" }}
          >
            Feed Created Successfully!
          </Alert>
        </Snackbar>
      </Box>
    </div>
  );
};

export default Index;
